import { SiteUtilities } from './utils';
const $ = jQuery;

const intersectionObserverCompatibility = ('IntersectionObserver' in window) &&
  ('IntersectionObserverEntry' in window) &&
  ('intersectionRatio' in window.IntersectionObserverEntry.prototype) &&
  ('isIntersecting' in window.IntersectionObserverEntry.prototype);

const lazyLoader = () => {
  // Check for intersection observer.
  // We need to check for mutilple properties to check for browsers with partial implementation.
  if (intersectionObserverCompatibility) {
    const intersectionObserverConfig = {
      root: null,
      threshold: 0.1
    };
    try {
      const observer = new window.IntersectionObserver((entries, self) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const $imageElement = $(entry.target);
            if ($imageElement.hasClass('lazy-image')) {
              loadImageFromThumbnail($imageElement);
            } else {
              loadOriginalImage($imageElement);
            }
            // Unobserve the target as the image has loaded.
            self.unobserve(entry.target);
          }
        });
      }, intersectionObserverConfig);

      // Observe the elements.
      $('.lazy-image').each((index, imageElement) => {
        observer.observe(imageElement);
      });

      $('.loading-optimized .original-image').each((index, imageElement) => {
        observer.observe(imageElement);
      });
    } catch (e) {
      SiteUtilities.log(
        'Intersection Observer Error',
        'error',
        'lazy-loader',
        1,
        e
      );
    }
  } else {
    $('.lazy-image').each((index, imageElement) => {
      loadImageFromThumbnail($(imageElement));
    });
    $('.loading-optimized .original-image').each((index, imageElement) => {
      loadOriginalImage($(imageElement));
    });
  }
};

const loadImageFromThumbnail = ($imageElement) => {
  const $originalImage = $imageElement.siblings('.original-image');
  $originalImage.attr('srcset', $imageElement.attr('data-srcset'));
  $originalImage.attr('src', $imageElement.attr('data-src'));
  $originalImage.one('load', function () {
    $originalImage.closest('.lazy-image-wrapper').addClass('loaded');
    setTimeout(function () {
      $originalImage.siblings('.lazy-image').remove();
    }, 125);
  });
};

const loadOriginalImage = ($imageElement) => {
  if (!($imageElement.closest('.lazy-image-wrapper').hasClass('loaded'))) {
    $imageElement.attr('srcset', $imageElement.attr('data-srcset'));
    $imageElement.attr('src', $imageElement.attr('data-src'));
    $imageElement.one('load', function () {
      $imageElement.closest('.lazy-image-wrapper').addClass('loaded');
      $imageElement.removeAttr('data-src');
      $imageElement.removeAttr('data-srcset');
    });
  }
};

export {
  intersectionObserverCompatibility,
  lazyLoader
};
